export const breadcrumbs = {
  breadcrumbHome: "Home",
  breadcrumbCasino: "Casino",
  breadcrumbLottery: "Lottery",
  breadcrumbRaffles: "Raffles",
  breadcrumbNews: "News",
  breadcrumbArticle: "Article",
  breadcrumbSports: "Sports",
  breadcrumbGameFeed: "Game Feed",
  breadcrumbMyTickets: "My Tickets",
  breadcrumbResults: "Results",
  breadcrumbAllGames: "All Games",
  breadcrumbGames: "Games",
  breadcrumbTerms: "Terms and Conditions",
  breadcrumbDeleteAccount: "Delete Account",
  breadcrumbProfile: "Profile",
  breadcrumbProvider: "Provider",
  breadcrumbHorses: "Horses",
  breadcrumbMiniJuegos: "Mini Games",
  breadcrumbFavorites: "Favorites",
};
